import {
  StyledFacebookIcon,
  StyledAppleIcon,
  StyledGoogleIcon,
  StyledMailIcon,
  StyledFlex,
} from "./style";

export const SocialLogo = ({ social }: { social: string }) => {
  switch (social) {
    case "facebook":
      return (
        <StyledFlex>
          <StyledFacebookIcon />
          פייסבוק
        </StyledFlex>
      );
    case "google":
      return (
        <StyledFlex>
          <StyledGoogleIcon />
          גוגל
        </StyledFlex>
      );
    case "apple":
      return (
        <StyledFlex>
          <StyledAppleIcon />
          אפל
        </StyledFlex>
      );
    case "email":
      return (
        <StyledFlex>
          <StyledMailIcon />
          אימייל
        </StyledFlex>
      );
    default:
      return <StyledFlex>-</StyledFlex>;
  }
};
